import api from './api';

export interface UserProfile {
  id: string;
  keycloakId: string;
  name: string;
  mobile: string;
  role: 'admin' | 'agent';
  status: 'active' | 'inactive';
  createdAt: string;
}

export const usersService = {
  list: () => api.get<UserProfile[]>('/users').then((r) => r.data),
  getMe: () => api.get<UserProfile>('/users/me').then((r) => r.data),
  updateMe: (data: { name?: string; mobile?: string }) =>
    api.patch<UserProfile>('/users/me', data).then((r) => r.data),
  create: (data: { name: string; mobile: string; role: string }) =>
    api.post<UserProfile>('/users', data).then((r) => r.data),
  updateRole: (id: string, role: string) =>
    api.patch<UserProfile>(`/users/${id}/role`, { role }).then((r) => r.data),
  deactivate: (id: string) => api.patch<UserProfile>(`/users/${id}/deactivate`).then((r) => r.data),
  activate: (id: string) => api.patch<UserProfile>(`/users/${id}/activate`).then((r) => r.data),
};
